import { render } from "./TokenInfo.vue?vue&type=template&id=03446d54&scoped=true"
import script from "./TokenInfo.vue?vue&type=script&lang=js"
export * from "./TokenInfo.vue?vue&type=script&lang=js"

import "./TokenInfo.vue?vue&type=style&index=0&id=03446d54&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03446d54"]])

export default __exports__